import { render, staticRenderFns } from "./1-akuvox.vue?vue&type=template&id=ecfc9ebc&scoped=true&"
import script from "./1-akuvox.vue?vue&type=script&lang=ts&"
export * from "./1-akuvox.vue?vue&type=script&lang=ts&"
import style0 from "./1-akuvox.vue?vue&type=style&index=0&id=ecfc9ebc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfc9ebc",
  null
  
)

export default component.exports